import React from 'react';
import ActionButton from '../../library/input/buttons/button/SarasButton'
import SarasMenu from '../../library/repeater/menu/SarasMenu'
import SarasFormMenuRow from '../../library/repeater/menu/SarasFormMenuRow'

const DocChildActivator = (props) => {
    const { formObject, action, rowKey, headerKey } = props;

    const viewData = formObject.getFormData(rowKey, headerKey,action.paramName);

    const getSelectedRow = (value) => {
        if(value){
            let selectedItem = childComp[value];
            if(!selectedItem)
                selectedItem = childComp[Object.keys(childComp)[value]]
            return selectedItem
        }
    }

    const onLinkCLick = (e, value) => {
    // const onLinkCLick = (index) => {
        let selectedItem = getSelectedRow(value);
        let datalist = selectedItem.dataList;
        let customAction = action;
        //var actionParam = formObject.convertStrToKeyValue(datalist.actionParam)
        if(!customAction.actionParam)
            customAction.actionParam = {}
        
        customAction["actionName"] = datalist.actionName;
        customAction.actionParam = {...customAction.actionParam, dtId2:datalist.dtId2, dId2:datalist.dId2,ccompoId:datalist.ccompoId,
            dtId:formObject.masterKeys.dtId , dId:formObject.masterKeys.dId, popup:"p"
        }
        
        formObject.onFormAction(customAction, rowKey, headerKey);
    }

    const renderChildMenu = () => {
        //const MenuIcon = Icon[icon];
        return (
            <ActionButton className=""
                starIcon="more"
                onlyIcon={true}
                tooltip="More Options"
                starIconClassName="uiColorNeutralAction"
                style={{margin:"unset"}}  />
        )
    }

    if(!viewData)
        return(null)

    let childComp = viewData.childRows[0].rowValues;

    return (
        <SarasMenu menuTrigger={renderChildMenu()} hideTriggerIfNoOptions={1}
            dataList={Object.values(childComp)}
            menuItem={SarasFormMenuRow} onSelection={onLinkCLick} />
    )
}

export default DocChildActivator;
